import { useEffect, useState } from "react";
import { Link } from "wouter";
import { Snowflake } from "lucide-react";
import { openNewYearBooking } from "@/components/booking-modal";
import { isCampaignActive, NY_PATH } from "@/components/new-year/campaign";

/** Match prerendered HTML on hydration, then check the campaign on the client. */
export function useNewYearBannerActive() {
  const [active, setActive] = useState(false);
  useEffect(() => {
    const update = () => setActive(isCampaignActive());
    update();
    const id = window.setInterval(update, 60_000);
    return () => window.clearInterval(id);
  }, []);
  return active;
}

export function NewYearTopBanner() {
  return (
    <div
      className="ny-topbar fixed top-0 left-0 right-0 z-[66] text-white"
      role="region"
      aria-label="Императорский Новый год 2027"
      data-testid="banner-new-year-top"
    >
      <div className="container mx-auto h-full px-4 md:px-14 flex items-center justify-between gap-3">
        <Link
          href={NY_PATH}
          className="flex items-center gap-2 min-w-0 min-h-11 hover:opacity-85 transition-opacity"
          data-testid="link-new-year-top-banner"
        >
          <Snowflake className="w-3.5 h-3.5 shrink-0" style={{ color: "hsl(var(--ny-gold))" }} strokeWidth={1.5} aria-hidden="true" />
          <span className="font-serif italic text-[13px] sm:text-[16px] leading-tight text-white/95">
            <span className="block sm:inline">Императорский </span>
            <span className="block sm:inline whitespace-nowrap">Новый год <span style={{ color: "hsl(var(--ny-gold))" }}>2027</span></span>
          </span>
          <span className="hidden sm:inline text-[9px] tracking-[0.3em] uppercase text-white/55 border-l pl-2.5 whitespace-nowrap" style={{ borderColor: "hsl(var(--ny-gold) / 0.35)" }}>
            31 декабря · 22:00
          </span>
        </Link>
        <button
          type="button"
          onClick={() => openNewYearBooking("site_top_banner")}
          className="ny-topbar-btn shrink-0 min-h-11 px-3 md:px-4 py-2 text-[9px] tracking-[0.2em] uppercase whitespace-nowrap"
          data-testid="button-new-year-top-banner-book"
        >
          Забронировать
        </button>
      </div>
    </div>
  );
}
